module.exports = __webpack_public_path__ + "img/icon-floor-call.935e926c.svg";